import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from '@services/subscription';
import { PlanAddonSummary } from '@models/subscription';

/**
 * Sprint 17, story-082 (run 2 correction). The org's own current base plan's linked add-ons —
 * used by the Add Seats flow (AddAddonModal / OrganizationSeats / users.tsx out-of-seats) to
 * decide whether to show the purchase form or the upgrade list, instead of the public
 * useSubscriptionPlans(), which cannot see a private-plan org's own links.
 */
export const useLinkedAddOnsForOrganization = (options?: { enabled?: boolean }) => {
  return useQuery<PlanAddonSummary[]>({
    queryKey: ['linkedAddOnsForOrganization'],
    queryFn: () => subscriptionService.getLinkedAddOnsForOrganization(),
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 1,
    enabled: options?.enabled !== false,
  });
};

export default useLinkedAddOnsForOrganization;
